"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styles_1 = require("@material-ui/core/styles");
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var Icon_1 = require("../Icon");
var IconButton_1 = require("../IconButton");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        field: {
            margin: theme.spacing(1),
        },
    });
});
var SearchField = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'Search' : _b, _c = _a.label, label = _c === void 0 ? 'Search' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? true : _d, onClear = _a.onClear, onChange = _a.onChange, inputProps = __rest(_a, ["placeholder", "label", "fullWidth", "onClear", "onChange"]);
    var classes = useStyles();
    var _e = (0, react_1.useState)(''), state = _e[0], setState = _e[1];
    var onLocalClear = function (e) {
        setState('');
        if (onClear)
            onClear(e);
    };
    var onLocalChange = function (e) {
        setState(e.target.value);
        if (onChange)
            onChange(e);
    };
    return ((0, jsx_runtime_1.jsx)(FormControl_1.default, __assign({ fullWidth: fullWidth, className: classes.field }, { children: (0, jsx_runtime_1.jsx)(Input_1.default, __assign({}, inputProps, { placeholder: placeholder, inputProps: { 'aria-label': "".concat(label || 'Search') }, value: state, onChange: onLocalChange, endAdornment: (0, jsx_runtime_1.jsx)(InputAdornment_1.default, __assign({ position: "end" }, { children: state ? ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { id: "SearchIconButton", iconWidth: 16, iconHeight: 16, onClick: onLocalClear, selectedBgColor: "#FFF", icon: (0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ simple: true, isSelected: true, size: "small" }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) })) })) : ((0, jsx_runtime_1.jsx)(Search_1.default, {})) })), fullWidth: true })) })));
};
exports.SearchField = SearchField;
